<template>
  <ContentWrap>
    <el-form ref="queryFormRef" :inline="true" :model="queryParams" class="-mb-15px" label-width="80px">
      <el-form-item label="酒店" prop="shopId">
        <el-select
          v-model="queryParams.shopId"
          placeholder="全部酒店"
          clearable
          filterable
          class="!w-220px"
        >
          <el-option v-for="item in shopList" :key="item.id" :label="item.name" :value="item.id" />
        </el-select>
      </el-form-item>
      <el-form-item label="订单编号" prop="orderNo">
        <el-input
          v-model="queryParams.orderNo"
          placeholder="请输入订单编号"
          clearable
          class="!w-220px"
          @keyup.enter="handleQuery"
        />
      </el-form-item>
      <el-form-item label="入住人" prop="guestName">
        <el-input
          v-model="queryParams.guestName"
          placeholder="请输入入住人姓名"
          clearable
          class="!w-180px"
          @keyup.enter="handleQuery"
        />
      </el-form-item>
      <el-form-item label="订单状态" prop="status">
        <el-select v-model="queryParams.status" placeholder="全部状态" clearable class="!w-160px">
          <el-option
            v-for="item in statusOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleQuery">
          <Icon class="mr-5px" icon="ep:search" />
          搜索
        </el-button>
        <el-button @click="resetQuery">
          <Icon class="mr-5px" icon="ep:refresh" />
          重置
        </el-button>
      </el-form-item>
    </el-form>
  </ContentWrap>

  <ContentWrap>
    <el-table v-loading="loading" :data="list">
      <el-table-column label="订单编号" prop="orderNo" min-width="180" show-overflow-tooltip />
      <el-table-column label="酒店" prop="shopName" min-width="160" show-overflow-tooltip>
        <template #default="scope">{{ scope.row.shopName || `酒店#${scope.row.shopId}` }}</template>
      </el-table-column>
      <el-table-column label="房型" prop="spuName" min-width="140" show-overflow-tooltip>
        <template #default="scope">{{ scope.row.spuName || '-' }}</template>
      </el-table-column>
      <el-table-column label="入住人" prop="guestName" width="100" align="center" />
      <el-table-column label="入住 / 离店" width="200" align="center">
        <template #default="scope">{{ scope.row.checkInDate }} ~ {{ scope.row.checkOutDate }}</template>
      </el-table-column>
      <el-table-column label="实付金额" width="120" align="center">
        <template #default="scope">¥{{ money(scope.row.payAmount) }}</template>
      </el-table-column>
      <el-table-column label="订单状态" width="100" align="center">
        <template #default="scope">
          <el-tag :type="statusTagType(scope.row.status)">{{ statusLabel(scope.row.status) }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        :formatter="dateFormatter"
        label="创建时间"
        prop="createTime"
        width="180"
        align="center"
      />
      <el-table-column label="操作" width="190" fixed="right" align="center">
        <template #default="scope">
          <el-button
            v-hasPermi="['hotel:platform:order:detail', 'hotel:platform:order:query']"
            link
            type="primary"
            @click="openDetail(scope.row.id)"
          >
            详情
          </el-button>
          <el-button
            v-if="canCancel(scope.row)"
            v-hasPermi="['hotel:platform:order:cancel']"
            link
            type="danger"
            @click="openCancel(scope.row)"
          >
            协助取消
          </el-button>
          <el-button
            v-if="canRefund(scope.row)"
            v-hasPermi="['hotel:platform:order:refund']"
            link
            type="warning"
            @click="openRefund(scope.row)"
          >
            协助退款
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <Pagination
      v-model:limit="queryParams.pageSize"
      v-model:page="queryParams.pageNo"
      :total="total"
      @pagination="getList"
    />
  </ContentWrap>

  <!-- 订单详情 -->
  <el-drawer v-model="detailVisible" title="订单详情" size="520px">
    <div v-loading="detailLoading">
      <el-descriptions :column="1" border>
        <el-descriptions-item label="订单编号">{{ detail.orderNo }}</el-descriptions-item>
        <el-descriptions-item label="酒店">{{ detail.shopName || `酒店#${detail.shopId}` }}</el-descriptions-item>
        <el-descriptions-item label="房型">{{ detail.spuName || '-' }}</el-descriptions-item>
        <el-descriptions-item label="房间号">{{ detail.roomNo || '-' }}</el-descriptions-item>
        <el-descriptions-item label="入住人">{{ detail.guestName }} / {{ detail.guestPhone }}</el-descriptions-item>
        <el-descriptions-item label="入住 / 离店">{{ detail.checkInDate }} ~ {{ detail.checkOutDate }}</el-descriptions-item>
        <el-descriptions-item label="订单金额">¥{{ money(detail.payAmount) }}</el-descriptions-item>
        <el-descriptions-item label="已退款">¥{{ money(detail.refundAmount) }}</el-descriptions-item>
        <el-descriptions-item label="订单状态">
          <el-tag :type="statusTagType(detail.status)">{{ statusLabel(detail.status) }}</el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="取消原因">{{ detail.cancelReason || '-' }}</el-descriptions-item>
        <el-descriptions-item label="备注">{{ detail.remark || '-' }}</el-descriptions-item>
      </el-descriptions>
      <div class="guest-title">入住人信息</div>
      <el-table :data="detail.guests || []" size="small">
        <el-table-column label="姓名" prop="guestName" min-width="100" />
        <el-table-column label="手机号" prop="guestPhone" min-width="130" />
        <el-table-column label="证件号" prop="idCard" min-width="160" show-overflow-tooltip />
      </el-table>
    </div>
  </el-drawer>

  <!-- 协助取消 -->
  <Dialog v-model="cancelVisible" title="客服协助取消" width="480px">
    <el-form :model="cancelForm" label-width="80px">
      <el-form-item label="订单编号">{{ cancelForm.orderNo }}</el-form-item>
      <el-form-item label="取消原因" required>
        <el-input
          v-model="cancelForm.cancelReason"
          :rows="3"
          type="textarea"
          maxlength="200"
          show-word-limit
          placeholder="请输入取消原因（将记录到订单）"
        />
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button :loading="cancelLoading" type="danger" @click="submitCancel">确认取消</el-button>
      <el-button @click="cancelVisible = false">关闭</el-button>
    </template>
  </Dialog>

  <!-- 协助退款 -->
  <Dialog v-model="refundVisible" title="客服协助退款" width="480px">
    <el-form :model="refundForm" label-width="90px">
      <el-form-item label="订单编号">{{ refundForm.orderNo }}</el-form-item>
      <el-form-item label="可退金额">¥{{ money(refundForm.maxAmount) }}</el-form-item>
      <el-form-item label="退款金额" required>
        <el-input-number
          v-model="refundForm.amount"
          :min="0.01"
          :max="refundForm.maxAmount"
          :precision="2"
          class="!w-200px"
        />
      </el-form-item>
      <el-form-item label="退款原因" required>
        <el-input
          v-model="refundForm.reason"
          :rows="3"
          type="textarea"
          maxlength="200"
          show-word-limit
          placeholder="请输入退款原因"
        />
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button :loading="refundLoading" type="warning" @click="submitRefund">确认退款</el-button>
      <el-button @click="refundVisible = false">关闭</el-button>
    </template>
  </Dialog>
</template>

<script lang="ts" setup>
import { dateFormatter } from '@/utils/formatTime'
import * as BookingOrderApi from '@/api/hotel/bookingOrder'
import type { BookingOrderVO } from '@/api/hotel/bookingOrder'
import { getShopSimpleList } from '@/api/hotel/platformShop'
import type { HotelPlatformShopOption } from '@/api/hotel/platformShop'

defineOptions({ name: 'HotelPlatformOrder' })

const message = useMessage()
const loading = ref(true)
const list = ref<BookingOrderVO[]>([])
const total = ref(0)
const shopList = ref<HotelPlatformShopOption[]>([])
const queryFormRef = ref()

const queryParams = reactive({
  pageNo: 1,
  pageSize: 20,
  shopId: undefined as string | number | undefined,
  orderNo: undefined as string | undefined,
  guestName: undefined as string | undefined,
  status: undefined as number | undefined
})

const statusOptions = [
  { value: 0, label: '待支付' },
  { value: 1, label: '已支付' },
  { value: 2, label: '已确认' },
  { value: 3, label: '已入住' },
  { value: 4, label: '已完成' },
  { value: 5, label: '已取消' }
]

const statusLabel = (status?: number) =>
  statusOptions.find((item) => item.value === status)?.label || '-'
const statusTagType = (status?: number) => {
  if (status === 3) return 'success'
  if (status === 4) return 'info'
  if (status === 5) return 'danger'
  if (status === 1 || status === 2) return 'warning'
  return 'info'
}
const money = (value?: number) => Number(value || 0).toFixed(2)
const canCancel = (row: BookingOrderVO) => [0, 1, 2].includes(row.status)
const canRefund = (row: BookingOrderVO) =>
  row.status !== 0 && row.status !== 5 && Number(row.payAmount || 0) - Number(row.refundAmount || 0) > 0

const getList = async () => {
  loading.value = true
  try {
    const data = await BookingOrderApi.getBookingOrderPage({
      ...queryParams,
      shopId: queryParams.shopId,
      orderNo: queryParams.orderNo || undefined,
      guestName: queryParams.guestName || undefined
    })
    list.value = data?.list || []
    total.value = data?.total || 0
  } finally {
    loading.value = false
  }
}

const handleQuery = () => {
  queryParams.pageNo = 1
  getList()
}

const resetQuery = () => {
  queryFormRef.value?.resetFields()
  queryParams.shopId = undefined
  queryParams.orderNo = undefined
  queryParams.guestName = undefined
  queryParams.status = undefined
  handleQuery()
}

// ==================== 详情 ====================
const detailVisible = ref(false)
const detailLoading = ref(false)
const detail = ref<Partial<BookingOrderVO>>({})

const openDetail = async (id: string | number) => {
  detailVisible.value = true
  detailLoading.value = true
  try {
    detail.value = (await BookingOrderApi.getDetailWithGuests(id)) || {}
  } finally {
    detailLoading.value = false
  }
}

// ==================== 协助取消 ====================
const cancelVisible = ref(false)
const cancelLoading = ref(false)
const cancelForm = reactive({ id: '' as string | number, orderNo: '', cancelReason: '' })

const openCancel = (row: BookingOrderVO) => {
  cancelForm.id = row.id
  cancelForm.orderNo = row.orderNo
  cancelForm.cancelReason = ''
  cancelVisible.value = true
}

const submitCancel = async () => {
  if (!cancelForm.cancelReason.trim()) {
    message.warning('请输入取消原因')
    return
  }
  cancelLoading.value = true
  try {
    await BookingOrderApi.cancelBookingOrder(cancelForm.id, cancelForm.cancelReason.trim())
    message.success('订单已取消')
    cancelVisible.value = false
    await getList()
  } finally {
    cancelLoading.value = false
  }
}

// ==================== 协助退款 ====================
const refundVisible = ref(false)
const refundLoading = ref(false)
const refundForm = reactive({
  id: '' as string | number,
  orderNo: '',
  maxAmount: 0,
  amount: 0,
  reason: ''
})

const openRefund = (row: BookingOrderVO) => {
  refundForm.id = row.id
  refundForm.orderNo = row.orderNo
  refundForm.maxAmount = Number(
    (Number(row.payAmount || 0) - Number(row.refundAmount || 0)).toFixed(2)
  )
  refundForm.amount = refundForm.maxAmount
  refundForm.reason = ''
  refundVisible.value = true
}

const submitRefund = async () => {
  if (!refundForm.amount || refundForm.amount <= 0) {
    message.warning('请输入退款金额')
    return
  }
  if (!refundForm.reason.trim()) {
    message.warning('请输入退款原因')
    return
  }
  await message.confirm('退款将影响订单、库存与结算，确认继续？')
  refundLoading.value = true
  try {
    await BookingOrderApi.refund(refundForm.id, refundForm.amount, refundForm.reason.trim())
    message.success('退款成功')
    refundVisible.value = false
    await getList()
  } finally {
    refundLoading.value = false
  }
}

onMounted(async () => {
  getList()
  shopList.value = (await getShopSimpleList()) || []
})
</script>

<style scoped lang="scss">
.guest-title {
  margin: 16px 0 8px;
  font-size: 14px;
  font-weight: 600;
  color: #1f2d3d;
}
</style>
